/** @format */

export const init = {
	charities: [],
	userCharityId: '',
	goodCauseName: null,
	goodCauseImage: null,
	goodCauseMessage: false,
	Parentcharityid: '',
	loading: true,
	messageKey: '',
	message: '',
	showMore: false,

	loader: false,
	messageValidtion: {},
};

export const reducer = (state, action) => {
	switch (action.type) {
		case 'set_charityData':
			return {
				...state,
				charities: action.charities,
				userCharityId: action.userCharityId,
				goodCauseName: action.goodCauseName,
				goodCauseImage: action.goodCauseImage,
				goodCauseMessage: action.goodCauseMessage,
				Parentcharityid: action.Parentcharityid,
				loading: action.loading,
			};

		case 'set_showMore':
			return {
				...state,
				showMore: action.showMore,
			};
		case 'set_loader':
			return {
				...state,
				loader: action.loader,
			};

		case 'set_userCharityId':
			return {
				...state,
				userCharityId: action.userCharityId,
			};

		case 'set_messageValidtion':
			return {
				...state,
				messageValidtion: action.messageValidtion,
				loader: action.loader,
			};

		case 'updated_charityValue':
			return {
				...state,
				userCharityId: action.userCharityId,
				Parentcharityid: action.Parentcharityid,
				goodCauseMessage: action.goodCauseMessage,
				goodCauseName: action.goodCauseName,
				goodCauseImage: action.goodCauseImage,
				messageKey: action.messageKey,
				message: action.message,
				loader: action.loader,
				showMore: action.showMore,
			};

		case 'remove_message':
			return {
				...state,
				message: action.message,
				messageKey: action.messageKey,
			};
		case 'error_message':
			return {
				...state,
				messageKey: action.messageKey,
				message: action.message,
				loader: action.loader,
			};
		default:
			return state;
	}
};
